module.exports = __webpack_public_path__ + "static/media/8.b9a64e86.jpg";